import { Box } from '@mui/material';
import { CheckCircleOutline } from '@portals/icons';
import React, { useEffect } from 'react';

import { LoadingDots } from '../LoadingDots/LoadingDots';
import { Typography } from '../Typography/Typography';

export interface RedirectBoxProps {
  headline?: string;
  bankName?: string;
  redirect(): void;
  timeout?: number;
}

export const RedirectBox: React.FC<RedirectBoxProps> = ({ headline, bankName, redirect, timeout = 3000 }) => {
  useEffect(() => {
    if (timeout) {
      setTimeout(() => {
        redirect();
      }, timeout);
    } else {
      redirect();
    }
  }, []);

  return (
    <Box alignSelf="center" textAlign="center">
      <CheckCircleOutline sx={{ color: 'green.main', fontSize: '48px' }} />
      <Typography variant="h4" innerPadding="vertical" color="text.primary">
        {headline ? headline : 'Sie werden jetzt weitergeleitet'}
      </Typography>
      {timeout && bankName ? (
        <Typography variant="body2" color="text.secondary" innerPadding="vertical">
          zur {bankName} ...
        </Typography>
      ) : null}
      <Box sx={{ color: 'text.secondary' }}>
        <LoadingDots />
      </Box>
    </Box>
  );
};
